import styled, { keyframes } from "styled-components";

export const DeviceModalWrapper = styled.div`
    padding-top: 16px;
    padding-bottom: 16px;
    display: flex;
    flex-direction: column;
`;

export const DeviceModalHeaderRow = styled.div`
    padding-inline: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;

    h3 {
        color: var(--fg-default, rgba(16, 24, 40, 1));
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
    }

    svg {
        cursor: pointer;
    }
`;

export const DeviceModalSubtitle = styled.h4`
    margin-bottom: 16px;
    padding-inline: 16px;
    color: var(--fg-soft, rgba(16, 24, 40, 0.75));
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
`;

export const DeviceModalMain = styled.div`
    padding-inline: 16px;
    display: flex;
    flex-direction: column;
`;

export const DeviceTabsWrapper = styled.div`
    .tabs-item {
        height: 48px;
        width: max-content;
        min-width: max-content;
        flex-grow: 0;

        .tabs-item__text {
            font-size: 14px;
            font-weight: 500;
            width: max-content;
        }
    }
`;

export const DeviceModalFooter = styled.div`
    padding: 12px 16px 0;
    border-top: 1px solid var(--border-soft, rgba(88, 93, 105, 0.25));
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    align-items: center;
    margin-top: 16px;

    button {
        width: 140px;
        
        @media screen and (max-width: 1000px) {
            width: 100%
        }
    }
`;

export const FooterLeft = styled.div`
    margin-right: auto;
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 24px;
`;

export const FooterStatus = styled.div`
    color: var(--fg-default, rgba(16, 24, 40, 1));
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
`;

export const FooterStatusOk = styled.div`
    color: var(--fg-default, rgba(16, 24, 40, 1));
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
`;

export const UploadArea = styled.div`
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 140px;
`;

export const DropZone = styled.div<{ $dragOver?: boolean }>`
    border: 1px dashed var(--border-default, rgba(88, 93, 105, 0.5));
    background: ${({ $dragOver }) => ($dragOver ? "rgba(255, 79, 18, 0.06)" : "transparent")};
    border-radius: 16px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.3s ease;

    &:hover {
        background: rgba(16, 24, 40, 0.02);
    }
`;

export const DropZoneInner = styled.div`
    color: var(--fg-muted, rgba(16, 24, 40, 0.55));
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;

    span {
        color: var(--functionbutton-primary-label-color-default, rgba(255, 79, 18, 1));
        font-weight: 500;
    }
`;

export const HintText = styled.div`
    color: var(--fg-muted, rgba(16, 24, 40, 0.55));
    font-size: 12px;
    font-weight: 400;
    text-align: center;
`;

export const HiddenFileInput = styled.input`
    display: none;
`;

export const FileChip = styled.div`
    display: flex;
    align-items: center;
    border: 1px solid var(--border-soft, rgba(88, 93, 105, 0.25));
    padding: 8px;
    border-radius: 16px;
    position: relative;
`;

export const FileChipLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 0;
    min-width: 0;
`;

export const FileThumb = styled.img`
    width: 48px;
    height: 48px;
    border-radius: 8px;
    object-fit: cover;
    margin-right: 8px;
`;

export const FileName = styled.div`
    color: var(--fg-default, rgba(16, 24, 40, 1));
    font-size: 12px;
    font-weight: 400;
    margin-right: 4px;
    
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const FileSize = styled.div`
    color: var(--fg-muted, rgba(16, 24, 40, 0.55));

    font-size: 12px;
    font-weight: 400;
`;

export const FileChipRight = styled.div`
    position: absolute;
    right: 8px;
    top: 8px;
    width: 18px;
    height: 18px;
    
    svg {
        width: 100%;
        height: 100%;
    }
`;

export const RemoveFileBtn = styled.button`
    line-height: 1;
    cursor: pointer;
`;

export const ErrorText = styled.div`
    color: var(--input-primary-hint-color-error, rgba(255, 38, 38, 1));
    font-size: 12px;
    font-weight: 400;
`;

export const ResultText = styled.div`
    color: var(--fg-default, rgba(16, 24, 40, 1));
    font-size: 14px;
    line-height: 18px;
    padding: 0 4px;
`;

export const PreviewBox = styled.div`
     margin-top: 8px;
    padding-inline: 12px;
`;

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

export const SpinnerWrap = styled.div`
    width: 20px;
    height: 20px;
`;

export const Spinner = styled.div`
    box-sizing: border-box;
    width: 20px;
    height: 20px;
    border: 3px solid rgba(16, 24, 40, 0.15);
    border-top-color: rgba(255, 79, 18, 1);
    border-radius: 50%;
    animation: ${spin} 0.8s linear infinite;
`;


export const InputWrapper = styled.div`
    width: 100%;
    max-width: 280px;
    margin: 0 auto;
`


export const NewDeviceSuccessContent = styled.div`
    padding: 16px 16px 12px;
    display: flex;
    flex-direction: column;
`

export const  NewDeviceSuccessHeaderRow = styled.div`
    padding-inline: 16px;
    display: flex;
    margin-bottom: 8px;
    justify-content: center;
    
    h3 {
        color: var(--fg-default, rgba(16, 24, 40, 1));

        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        text-align: center;
    }

    svg {
        cursor: pointer;
    }
`;

export const  NewDeviceSuccessSubtitle = styled.p`
    margin-bottom: 28px;

    color: var(--fg-soft, rgba(16, 24, 40, 0.75));

    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
`

export const  NewDeviceSuccessButtonsCol = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    
    > *, .button {
        width: 100%;
        height: 40px;
    }
`